<template>
  <div>
    <CrudList
        title="Historial de Coins"
        storeName="Coins_refunds"
        label-show="Ver"
        :canAdd="false"
        :canEdit="false"
        :canShow="true"
        :canDelete="false"
        :filters="filters"
        sortable
        canSearch
        next-link="/admin/notifications_cms"
        :breadcrumbs="[
    {
    text: 'Finanzas',
    disabled: false,
    href: '/admin/coins_refunds'
    },
    {
    text: 'Carga de coins',
    disabled: false,
    href: '#'
    }
    ]"
    >

      <!-- ----HEADER CELL------------------------------ -->
      <template v-slot:user="{ item }">
        {{ item.user_id?.name }} {{ item.user_id?.last_name }}
      </template>

      <template v-slot:user_enterprise="{ item }">
        {{ item.user_enterprise_id?.name || item.user_enterprise_id }}
      </template>

      <template v-slot:coins="{ item }">
        <p class="mb-0 text-no-wrap">
          {{ item.coins }}
        </p>
      </template>

      <template v-slot:comments="{ item }">
        {{ item.comments }}
      </template>

      <template v-slot:createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudList },
  data() {
    return {
      tmp_all_coins_refunds: {
        filters: {}
      },
      filters: {
        user_id: null,
        user_enterprise_id: null,
        search: null
      },
      offsetTop: 0,
    };
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    async updateCoinsRefunds() {
      if (
          JSON.stringify(this.filters) !==
          JSON.stringify(this.tmp_all_coins_refunds.filters)
      ) {
        await this.$store.dispatch(
            "Coins_refunds/getListAll",
            { show_all: "enable", ...this.filters }
        );
        this.tmp_all_coins_refunds.filters = { ...this.filters };
      }
    },
    formatDate(created_at) {
      if (!created_at) return null;
      let [date, time] = created_at.split("T");
      const [year, month, day] = date.split("-");
      time = (time.split(".")[0]);
      return `${day}/${month}/${year}`;
    },
  }
};
</script>
